import { BrandCodesRequest } from 'src/modules/generated/api';

// Mirrors the BE enum BrandGroup, which is only exposed as a map key in the generated API
export const SEAT_CUPRA = 'SEAT_CUPRA';

export type BrandGroup = typeof SEAT_CUPRA;

export type Address = {
  name: string;
  companyName: string;
  street: string;
  city: string;
  zip: string;
  country: string;
  countryCode: string;
  email: string;
  phoneNumber: string;
  faxNumber?: string;
  additionalInformation?: string;
  betriebsId?: string;
  addressCode?: string;
  brandOverrides?: Partial<Record<BrandGroup, BrandCodesRequest>>;
};
